export const uk = {
    banner: 'Объявление',
    'campaign-group': 'Кампания/Группа',
    'campaign-type': 'Тип кампании',
    price: 'Цена в объявлении',
    status: 'Статус',
    type: 'Тип'
};
